import React, { Component } from 'react';
import { Tile } from '../../components';

import { ThemeColors } from '../../theme';
import Slider from 'react-slick';
import { Typography } from '@material-ui/core';

const INITIAL_STATE = {

};

const unslickIfLessThanLength = (size, length) => size >= length ? 'unslick' : { slidesToShow: size, slidesToScroll: Math.min(2, size) };
class Group extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
  }


  render() {
    const filteredChilds = this.props.group.children.filter(c => !!c);
    const childLength = filteredChilds.length;
    const settings = {
      dots: false,
      infinite: false,
      centerMode: false,
      className: 'slider',
      nextArrow: <div />,
      prevArrow: <div />,
      responsive: [
      { breakpoint: 580, settings: unslickIfLessThanLength(1, childLength) },
      { breakpoint: 830, settings: unslickIfLessThanLength(2, childLength) },
      { breakpoint: 1024, settings: unslickIfLessThanLength(4, childLength) },
      { breakpoint: 1620, settings: unslickIfLessThanLength(4, childLength) },
      { breakpoint: 1900, settings: unslickIfLessThanLength(6, childLength) },
      { breakpoint: 100000, settings: unslickIfLessThanLength(7, childLength) }],
    };
    return (
      <div style={{ minHeight: 360 }}>
        <div className="col-md-12 col-lg-10 col-sm-12">
          <div style={{ paddingLeft: '5px' }}>
            <Typography variant="h1">{this.props.group.name}</Typography>
            {/* <h1 style={{ color: ThemeColors.primary1Color, fontSize: 14 }}>{this.props.group.name}</h1> */}
          </div>
        </div>
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 tileGroup">
          <Slider {...settings}>
            { filteredChilds.map((course, i) => <Tile
              className={'tile'}
              key={i}
              title={course.name}
              course={course}
              isPinned={course.isPinned}
              onClick={() => this.props.onClick(course)}
              imageUrl={course.imageUrl}
              progress={course.progress}
              onClickShare={(e) => {
                e.stopPropagation();
                this.props.onClickShare(course);
              }}
            />)}
          </Slider>
          <div
            style={{
              position: 'absolute',
              height: '100%',
              width: 150,
            // background: 'linear-gradient(to right, rgba(255,255,255,0), white)',
              right: 0,
              top: 0 }}
          />
        </div>
      </div>
    );
  }
}

const styles = {
  buttonStyle: {
    fontSize: '14px',
    height: 60,
  },
  sideButtonStyle: {
    width: '100%',
    marginBottom: '20px',
    height: 60,
  },
};

export default Group;



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/group.js